"use client";
import { cva as e } from "class-variance-authority";
const a = e(
  ["transition-all data-[disable-transitions]:transition-none", "duration-100 ease-in-out"],
  {
    variants: {
      slot: {
        root: [
          "group w-full overflow-hidden border rounded-lg",
          "text-inkeep-primary-text-bold selected:text-inkeep-primary-strong",
          "focus:outline-inkeep-expanded-primary-700 dark:focus:outline-inkeep-expanded-primary-300",
          "dark:text-white-alpha-950 dark:selected:text-inkeep-expanded-primary-300",
          "bg-white selected:bg-inkeep-primary-light-subtle",
          "dark:bg-transparent dark:selected:bg-white-alpha-200",
          "border-gray-200 selected:border-inkeep-primary-medium-subtle",
          "dark:border-white-alpha-200",
          "dark:selected:border-inkeep-expanded-primary-300",
          "py-2 px-5 grid gap-x-3 gap-y-1",
          '[grid-template:"breadcrumbs_breadcrumbs_breadcrumbs_indicator""icon_title_tag_indicator""description_description_description_indicator"/auto_auto_1fr_auto]',
          "items-center",
          'md:data-[view=dual-pane]:[grid-template:"breadcrumbs_breadcrumbs_breadcrumbs""icon_title_tag""description_description_description"/auto_auto_1fr]'
        ],
        breadcrumbs: [
          "[grid-area:breadcrumbs]",
          "whitespace-nowrap line-clamp-1",
          "flex items-center text-gray-600",
          "dark:text-white-alpha-600 text-xs truncate inline-block"
        ],
        breadcrumbsIcon: "last-of-type:hidden text-3xs mx-[5px]",
        icon: [
          "[grid-area:icon]",
          "text-gray-500",
          "group-selected:text-inkeep-primary-text-subtle",
          "dark:text-gray-dark-300 dark:group-selected:text-gray-dark-100"
        ],
        title: [
          "[grid-area:title]",
          "text-gray-800 dark:text-white-alpha-950",
          "group-selected:text-inkeep-primary-text-bold",
          "dark:group-selected:text-white",
          "font-medium line-clamp-1",
          "whitespace-nowrap text-ellipsis inline-block"
        ],
        tag: [
          "[grid-area:tag] w-fit justify-self-end",
          "text-xs px-1 uppercase rounded-sm align-middle",
          "font-bold inline-block whitespace-nowrap",
          'data-[type^="github"]:text-purple-500',
          'data-[type="stackoverflow"]:text-green-500',
          "shadow-[inset_0_0_0_1px_currentColor]"
        ],
        description: [
          "[grid-area:description]",
          "text-1sm line-clamp-1",
          "text-gray-700 dark:text-white-alpha-700"
        ],
        descriptionPart: [
          "data-[highlighted]:font-semibold",
          "data-[highlighted]:text-inkeep-primary-text-subtle",
          "dark:data-[highlighted]:text-gray-dark-50"
        ],
        indicator: [
          "[grid-area:indicator]",
          "self-center justify-self-end",
          "opacity-0 group-selected:opacity-100",
          "transition-opacity duration-100 ease-in-out ml-auto",
          "md:data-[view=dual-pane]:hidden"
        ]
      }
    }
  }
);
export {
  a as citation
};
